export default "__VITE_ASSET__acc84d64__"